import React from "react";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
  makeStyles,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    borderRadius: "12px",
  },
  cardMedia: {
    height: 250,
  },
  chipRoot: {
    borderRadius: "8px",
  },
}));

export function UniversityCard(props) {
  const history = useHistory();

  const classes = useStyles();
  const {
    name,
    location,
    campusImage,
    localeClass,
    collegeId,
    rankingsBestColleges,
  } = props.college;
  return (
    <Box m={2}>
      <Card
        className={classes.cardRoot}
        elevation={4}
        onClick={() => {
          history.push(`/college/${collegeId}`);
        }}
      >
        <CardActionArea>
          <CardMedia
            className={classes.cardMedia}
            image={campusImage}
            title={name}
          />
          <CardContent>
            <Box
              component="div"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="pre-line"
              height={50}
            >
              <Typography gutterBottom variant="h6">
                {name}
              </Typography>
            </Box>
            <Box my={1} display="flex" justifyContent="start">
              <Chip
                classes={{ root: classes.chipRoot }}
                className="mr-1"
                color="primary"
                size="small"
                style={{ backgroundColor: "#bbeafd" }}
                label={location}
              />
              <Chip
                classes={{ root: classes.chipRoot }}
                className="mr-1"
                color="primary"
                size="small"
                style={{ backgroundColor: "#fab29c" }}
                label={localeClass}
              />
              {rankingsBestColleges ? (
                <Chip
                  classes={{ root: classes.chipRoot }}
                  color="primary"
                  size="small"
                  style={{ backgroundColor: "#feecec", color: "#e6434d" }}
                  label={`#${rankingsBestColleges.value} of ${rankingsBestColleges.total}`}
                />
              ) : (
                ""
              )}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
}
